!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports["react-simple-tree-menu"] = t(require("react")) : e["react-simple-tree-menu"] = t(e.react);
}(window, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "/dist/", n(n.s = 13);
  }([function (e, t, n) {
    var r = n(5),
        o = "object" == typeof self && self && self.Object === Object && self,
        c = r || o || Function("return this")();
    e.exports = c;
  }, function (e, t, n) {
    var r = n(6),
        o = n(20),
        c = n(21),
        i = "[object Null]",
        u = "[object Undefined]",
        a = r ? r.toStringTag : void 0;

    e.exports = function (e) {
      return null == e ? void 0 === e ? u : i : a && a in Object(e) ? o(e) : c(e);
    };
  }, function (e, t, n) {
    var r = n(29),
        o = n(32);

    e.exports = function (e, t) {
      var n = o(e, t);
      return r(n) ? n : void 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t, n) {
    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.exports = n;
    }).call(this, n(17));
  }, function (e, t, n) {
    var r = n(0).Symbol;
    e.exports = r;
  }, function (t, n) {
    t.exports = e;
  }, function (e, t) {
    var n = Object.prototype;

    e.exports = function (e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || n);
    };
  }, function (e, t, n) {
    var r = n(1),
        o = n(3),
        c = "[object AsyncFunction]",
        i = "[object Function]",
        u = "[object GeneratorFunction]",
        a = "[object Proxy]";

    e.exports = function (e) {
      if (!o(e)) return !1;
      var t = r(e);
      return t == i || t == u || t == c || t == a;
    };
  }, function (e, t) {
    var n = Function.prototype.toString;

    e.exports = function (e) {
      if (null != e) {
        try {
          return n.call(e);
        } catch (e) {}

        try {
          return e + "";
        } catch (e) {}
      }

      return "";
    };
  }, function (e, t) {
    var n = 9007199254740991;

    e.exports = function (e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= n;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, n) {
    "use strict";

    var r;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = ((r = n(14)) && r.__esModule ? r : {
      default: r
    }).default;
    t.default = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = u(n(15)),
        o = u(n(7)),
        c = u(n(22)),
        i = n(47);

    function u(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var _a,
        f = (_a = function a(e, t) {
      return (_a = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _a(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        _l = function l() {
      return (_l = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        p = function p(e) {
      return console.log(e);
    },
        s = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          openNodes: t.props.initialOpenNodes || [],
          searchTerm: "",
          activeKey: t.props.initialActiveKey || ""
        }, t.onSearch = function (e) {
          var n = t.props.debounceTime;
          (0, r.default)(function (e) {
            return t.setState({
              searchTerm: e
            });
          }, n)(e);
        }, t.toggleNode = function (e) {
          if (!t.props.openNodes) {
            var n = t.state.openNodes,
                r = n.includes(e) ? n.filter(function (t) {
              return t !== e;
            }) : n.concat([e]),
                o = t.props.activeKey || e;
            t.setState({
              openNodes: r,
              activeKey: o
            });
          }
        }, t.generateItems = function () {
          var e = t.props,
              n = e.data,
              r = e.onClickItem,
              o = e.locale,
              i = t.state.searchTerm,
              u = t.props.openNodes || t.state.openNodes,
              a = t.props.activeKey || t.state.activeKey;
          return (0, c.default)({
            data: n,
            openNodes: u,
            searchTerm: i,
            locale: o
          }).map(function (e) {
            var n = e.key;
            return _l({}, e, {
              active: n === a,
              onClick: function onClick() {
                t.toggleNode(e.key), r(e);
              }
            });
          });
        }, t;
      }

      return f(t, e), t.prototype.render = function () {
        var e = this.props,
            t = e.data,
            n = e.children,
            r = this.onSearch,
            o = t ? this.generateItems() : [];
        return (n || i.defaultChildren)({
          search: r,
          items: o
        });
      }, t.defaultProps = {
        data: {},
        onClickItem: p,
        debounceTime: 125,
        children: i.defaultChildren
      }, t;
    }(o.default.Component);

    t.default = s;
  }, function (e, t, n) {
    var r = n(3),
        o = n(16),
        c = n(18),
        i = "Expected a function",
        u = Math.max,
        a = Math.min;

    e.exports = function (e, t, n) {
      var f,
          l,
          p,
          s,
          d,
          v,
          y = 0,
          b = !1,
          j = !1,
          m = !0;
      if ("function" != typeof e) throw new TypeError(i);

      function h(t) {
        var n = f,
            r = l;
        return f = l = void 0, y = t, s = e.apply(r, n);
      }

      function x(e) {
        var n = e - v;
        return void 0 === v || n >= t || n < 0 || j && e - y >= p;
      }

      function O() {
        var e = o();
        if (x(e)) return g(e);
        d = setTimeout(O, function (e) {
          var n = t - (e - v);
          return j ? a(n, p - (e - y)) : n;
        }(e));
      }

      function g(e) {
        return d = void 0, m && f ? h(e) : (f = l = void 0, s);
      }

      function w() {
        var e = o(),
            n = x(e);

        if (f = arguments, l = this, v = e, n) {
          if (void 0 === d) return function (e) {
            return y = e, d = setTimeout(O, t), b ? h(e) : s;
          }(v);
          if (j) return d = setTimeout(O, t), h(v);
        }

        return void 0 === d && (d = setTimeout(O, t)), s;
      }

      return t = c(t) || 0, r(n) && (b = !!n.leading, p = (j = "maxWait" in n) ? u(c(n.maxWait) || 0, t) : p, m = "trailing" in n ? !!n.trailing : m), w.cancel = function () {
        void 0 !== d && clearTimeout(d), y = 0, f = v = l = d = void 0;
      }, w.flush = function () {
        return void 0 === d ? s : g(o());
      }, w;
    };
  }, function (e, t, n) {
    var r = n(0);

    e.exports = function () {
      return r.Date.now();
    };
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(3),
        o = n(19),
        c = NaN,
        i = /^\s+|\s+$/g,
        u = /^[-+]0x[0-9a-f]+$/i,
        a = /^0b[01]+$/i,
        f = /^0o[0-7]+$/i,
        l = parseInt;

    e.exports = function (e) {
      if ("number" == typeof e) return e;
      if (o(e)) return c;

      if (r(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = r(t) ? t + "" : t;
      }

      if ("string" != typeof e) return 0 === e ? e : +e;
      e = e.replace(i, "");
      var n = a.test(e);
      return n || f.test(e) ? l(e.slice(2), n ? 2 : 8) : u.test(e) ? c : +e;
    };
  }, function (e, t, n) {
    var r = n(1),
        o = n(4),
        c = "[object Symbol]";

    e.exports = function (e) {
      return "symbol" == typeof e || o(e) && r(e) == c;
    };
  }, function (e, t, n) {
    var r = n(6),
        o = Object.prototype,
        c = o.hasOwnProperty,
        i = o.toString,
        u = r ? r.toStringTag : void 0;

    e.exports = function (e) {
      var t = c.call(e, u),
          n = e[u];

      try {
        e[u] = void 0;
        var r = !0;
      } catch (e) {}

      var o = i.call(e);
      return r && (t ? e[u] = n : delete e[u]), o;
    };
  }, function (e, t) {
    var n = Object.prototype.toString;

    e.exports = function (e) {
      return n.call(e);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r,
        o = (r = n(23)) && r.__esModule ? r : {
      default: r
    };

    var _c = function c() {
      return (_c = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    },
        i = function i(e, t) {
      var n = {};

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;

        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
          t.indexOf(r[o]) < 0 && (n[r[o]] = e[r[o]]);
        }
      }

      return n;
    },
        u = function u(e) {
      return !!e && !(0, o.default)(e);
    },
        a = function a(e) {
      return u(e) ? e : [];
    },
        f = function f(e) {
      var t,
          n = e.data,
          r = i(e, ["data"]),
          o = a(n),
          u = _c({
        parent: "",
        level: 0
      }, r);

      return Array.isArray(o) ? o.reduce(function (e, t, n) {
        var r = _c({
          node: t,
          index: n,
          nodeName: t.key
        }, u),
            o = p(r);

        return e.concat(o);
      }, []) : (t = o, Object.entries(t).sort(function (e, t) {
        return e[1].index - t[1].index;
      }).reduce(function (e, t) {
        var n = t[0],
            r = t[1],
            o = _c({
          node: r,
          nodeName: n
        }, u),
            i = p(o);

        return e.concat(i);
      }, []));
    },
        l = function l(e) {
      return e.label;
    },
        p = function p(e) {
      var t = e.node,
          n = e.nodeName,
          r = i(e, ["node", "nodeName"]),
          o = r.parent,
          p = r.level,
          s = r.openNodes,
          d = r.searchTerm,
          v = r.locale,
          y = void 0 === v ? l : v,
          b = t.nodes,
          j = t.label,
          m = void 0 === j ? "unknown" : j,
          h = i(t, ["nodes", "label"]),
          x = [o, n].filter(function (e) {
        return e;
      }).join("/"),
          O = u(b),
          g = O && (s.includes(x) || !!d),
          w = y(_c({
        label: m
      }, h)),
          _ = !d || function (e, t) {
        var n = function n(e) {
          return e.trim().toLowerCase();
        };

        return n(e).includes(n(t));
      }(w, d),
          P = _c({}, r, h, {
        label: w,
        hasNodes: O,
        isOpen: g,
        key: x
      }),
          T = a(b),
          S = g ? f(_c({
        data: T
      }, r, {
        parent: x,
        level: p + 1
      })) : [];

      return _ ? [P].concat(S) : S;
    },
        s = f;

    t.default = s;
  }, function (e, t, n) {
    var r = n(24),
        o = n(27),
        c = n(37),
        i = n(39),
        u = n(40),
        a = n(41),
        f = n(8),
        l = n(43),
        p = "[object Map]",
        s = "[object Set]",
        d = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      if (null == e) return !0;
      if (u(e) && (i(e) || "string" == typeof e || "function" == typeof e.splice || a(e) || l(e) || c(e))) return !e.length;
      var t = o(e);
      if (t == p || t == s) return !e.size;
      if (f(e)) return !r(e).length;

      for (var n in e) {
        if (d.call(e, n)) return !1;
      }

      return !0;
    };
  }, function (e, t, n) {
    var r = n(8),
        o = n(25),
        c = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      if (!r(e)) return o(e);
      var t = [];

      for (var n in Object(e)) {
        c.call(e, n) && "constructor" != n && t.push(n);
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(26)(Object.keys, Object);
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (n) {
        return e(t(n));
      };
    };
  }, function (e, t, n) {
    var r = n(28),
        o = n(33),
        c = n(34),
        i = n(35),
        u = n(36),
        a = n(1),
        f = n(10),
        l = f(r),
        p = f(o),
        s = f(c),
        d = f(i),
        v = f(u),
        y = a;
    (r && "[object DataView]" != y(new r(new ArrayBuffer(1))) || o && "[object Map]" != y(new o()) || c && "[object Promise]" != y(c.resolve()) || i && "[object Set]" != y(new i()) || u && "[object WeakMap]" != y(new u())) && (y = function y(e) {
      var t = a(e),
          n = "[object Object]" == t ? e.constructor : void 0,
          r = n ? f(n) : "";
      if (r) switch (r) {
        case l:
          return "[object DataView]";

        case p:
          return "[object Map]";

        case s:
          return "[object Promise]";

        case d:
          return "[object Set]";

        case v:
          return "[object WeakMap]";
      }
      return t;
    }), e.exports = y;
  }, function (e, t, n) {
    var r = n(2)(n(0), "DataView");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(9),
        o = n(30),
        c = n(3),
        i = n(10),
        u = /^\[object .+?Constructor\]$/,
        a = Function.prototype,
        f = Object.prototype,
        l = a.toString,
        p = f.hasOwnProperty,
        s = RegExp("^" + l.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    e.exports = function (e) {
      return !(!c(e) || o(e)) && (r(e) ? s : u).test(i(e));
    };
  }, function (e, t, n) {
    var r,
        o = n(31),
        c = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";

    e.exports = function (e) {
      return !!c && c in e;
    };
  }, function (e, t, n) {
    var r = n(0)["__core-js_shared__"];
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e, t, n) {
    var r = n(2)(n(0), "Map");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(2)(n(0), "Promise");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(2)(n(0), "Set");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(2)(n(0), "WeakMap");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(38),
        o = n(4),
        c = Object.prototype,
        i = c.hasOwnProperty,
        u = c.propertyIsEnumerable,
        a = r(function () {
      return arguments;
    }()) ? r : function (e) {
      return o(e) && i.call(e, "callee") && !u.call(e, "callee");
    };
    e.exports = a;
  }, function (e, t, n) {
    var r = n(1),
        o = n(4),
        c = "[object Arguments]";

    e.exports = function (e) {
      return o(e) && r(e) == c;
    };
  }, function (e, t) {
    var n = Array.isArray;
    e.exports = n;
  }, function (e, t, n) {
    var r = n(9),
        o = n(11);

    e.exports = function (e) {
      return null != e && o(e.length) && !r(e);
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(0),
          o = n(42),
          c = t && !t.nodeType && t,
          i = c && "object" == typeof e && e && !e.nodeType && e,
          u = i && i.exports === c ? r.Buffer : void 0,
          a = (u ? u.isBuffer : void 0) || o;
      e.exports = a;
    }).call(this, n(12)(e));
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t, n) {
    var r = n(44),
        o = n(45),
        c = n(46),
        i = c && c.isTypedArray,
        u = i ? o(i) : r;
    e.exports = u;
  }, function (e, t, n) {
    var r = n(1),
        o = n(11),
        c = n(4),
        i = {};
    i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, e.exports = function (e) {
      return c(e) && o(e.length) && !!i[r(e)];
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return e(t);
      };
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(5),
          o = t && !t.nodeType && t,
          c = o && "object" == typeof e && e && !e.nodeType && e,
          i = c && c.exports === o && r.process,
          u = function () {
        try {
          var e = c && c.require && c.require("util").types;

          return e || i && i.binding && i.binding("util");
        } catch (e) {}
      }();

      e.exports = u;
    }).call(this, n(12)(e));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.defaultChildren = void 0;
    var r,
        o = (r = n(7)) && r.__esModule ? r : {
      default: r
    };

    var c = function c(e) {
      var t = e.on;
      return o.default.createElement("div", {
        role: "img",
        "aria-label": "Toggle"
      }, t ? "-" : "+");
    },
        i = function i(e) {
      var t = e.hasNodes,
          n = void 0 !== t && t,
          r = e.isOpen,
          i = void 0 !== r && r,
          u = e.level,
          a = void 0 === u ? 0 : u,
          f = e.onClick,
          l = e.active,
          p = e.key,
          s = e.label,
          d = void 0 === s ? "unknown" : s;
      return o.default.createElement("li", {
        style: {
          padding: " .75rem  1rem  .75rem " + (3.5 + 1.25 * a) + "rem",
          cursor: "pointer",
          color: l ? "white" : "#333",
          background: l ? "#179ed3" : "none",
          borderBottom: "1px solid #ccc"
        },
        role: "button",
        "aria-pressed": l,
        onClick: f,
        key: p
      }, n && o.default.createElement("div", {
        style: {
          position: "absolute",
          left: 2 + 1.25 * a + "rem",
          width: "2rem",
          height: "2rem"
        }
      }, o.default.createElement(c, {
        on: i
      })), d);
    };

    t.defaultChildren = function (e) {
      var t = e.search,
          n = e.items;
      return o.default.createElement(o.default.Fragment, null, o.default.createElement("input", {
        style: {
          padding: "1rem 2rem",
          border: "none",
          width: "100%"
        },
        "aria-label": "Type and search",
        type: "search",
        placeholder: "Type and search",
        onChange: function onChange(e) {
          var n = e.target.value;
          t(n);
        }
      }), o.default.createElement("ul", {
        style: {
          listStyleType: "none",
          paddingLeft: 0,
          borderTop: "1px solid #ccc"
        }
      }, n.map(i)));
    };
  }]);
});